import React from "react";

export default function QuestionQcu({ question, value, onChange, disabled }) {
    return (
        <div className="qr-options-list">
            {(question.reponsesPossibles || []).map((option) => (
                <label key={option.id} className={`qr-option-card ${String(value) === String(option.id) ? "is-selected" : ""}`}>
                    <input
                        type="radio"
                        name={`question-${question.id}`}
                        value={option.id}
                        checked={String(value) === String(option.id)}
                        onChange={() => onChange(option.id)}
                        disabled={disabled}
                    />
                    <span>{option.libelle}</span>
                </label>
            ))}
        </div>
    );
}
